
<div style="padding: 20px; background: #ebebeb;">
    <hr-tab-group [activeTabIndex]="1">
        <hr-tab [label]="'პაროლის შეცვლა'">
            <h1>პაროლის შეცვლა</h1>
        </hr-tab>
        <hr-tab [label]="'ხელიმისაწვდომობა'">
            <h1>ხელიმისაწვდომობა</h1>
        </hr-tab>
        <hr-tab [label]="'შავი სია'">
            <h1>შავი სია</h1>
        </hr-tab>
    </hr-tab-group>
</div>


<button (click)="testCategoryPicker()">Test category picker</button>